module.exports = __webpack_public_path__ + "img/icon1.cad1a15a.png";